'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScreenPerformanceTrack = exports.isDirty = exports.getScreenUpdated = exports.getScreenInvalid = exports.getScreenCustom = exports.getScreenData = exports.getScreenArgs = exports.getScreenId = exports.getScreenMessages = exports.initialState = exports.ScreenState = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = screenReducer;

var _ScreenMessageActionCreators = require('../../components/screenmessage/actions/ScreenMessageActionCreators');

var _SetScreenIdAction = require('../../components/screen/actions/SetScreenIdAction');

var _SetScreenArgsAction = require('../../components/screen/actions/SetScreenArgsAction');

var _RemoveScreenArgsAction = require('../../components/screen/actions/RemoveScreenArgsAction');

var _SetScreenDataAction = require('../../components/screen/actions/SetScreenDataAction');

var _RemoveScreenDataAction = require('../../components/screen/actions/RemoveScreenDataAction');

var _SetScreenCustomAction = require('../../components/screen/actions/SetScreenCustomAction');

var _RemoveScreenCustomAction = require('../../components/screen/actions/RemoveScreenCustomAction');

var _SetScreenInvalidAction = require('../../components/screen/actions/SetScreenInvalidAction');

var _RemoveScreenInvalidAction = require('../../components/screen/actions/RemoveScreenInvalidAction');

var _SetScreenUpdatedAction = require('../../components/screen/actions/SetScreenUpdatedAction');

var _RemoveScreenUpdatedAction = require('../../components/screen/actions/RemoveScreenUpdatedAction');

var _PerformanceStartStoryActionCreator = require('../../components/screen/actions/PerformanceStartStoryActionCreator');

var _PerformanceEndStoryAction = require('../../components/screen/actions/PerformanceEndStoryAction');

var _ShowDialogAction = require('../../components/dialog/actions/ShowDialogAction');

var _HideDialogAction = require('../../components/dialog/actions/HideDialogAction');

var _NavigationResetAction = require('../../components/screen/actions/NavigationResetAction');

var _FieldEditUpdateAction = require('../../components/screen/actions/FieldEditUpdateAction');

var _AppEntryLoadDataAction = require('../../components/module/actions/AppEntryLoadDataAction');

var _ScreenKeyConst = require('../../components/screen/ScreenKeyConst');

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PerformanceTrack = (0, _immutable.Record)({
  name: 'None',
  id: ''
});

var ScreenState = exports.ScreenState = (0, _immutable.Record)({
  messages: (0, _immutable.List)(),
  id: '',
  args: (0, _immutable.Map)(),
  data: (0, _immutable.Map)(),
  custom: (0, _immutable.Map)(),
  invalid: (0, _immutable.Map)(),
  updated: (0, _immutable.Map)(),
  performanceTrack: new PerformanceTrack()
});

var initialState = exports.initialState = (0, _immutable.Map)((0, _defineProperty3.default)({}, _ScreenKeyConst.ACTIVE_SCREEN_KEY, new ScreenState()));

function screenReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];


  switch (action.type) {
    case _ScreenMessageActionCreators.SET_SCREEN_MESSAGE_ACTION:
      {
        return state.setIn([action.screenKey, 'messages'], (0, _immutable.fromJS)(action.messages));
      }
    case _ScreenMessageActionCreators.REMOVE_SCREEN_MESSAGE_ACTION:
      {
        return state.setIn([action.screenKey, 'messages'], (0, _immutable.fromJS)(action.messages));
      }
    case _SetScreenIdAction.SET_SCREEN_ID_ACTION:
      {
        return state.setIn([action.screenKey, 'id'], action.id);
      }
    case _SetScreenArgsAction.SET_SCREEN_ARGS_ACTION:
      {
        return state.setIn([action.screenKey, 'args'].concat(action.path), (0, _immutable.fromJS)(action.value));
      }
    case _RemoveScreenArgsAction.REMOVE_SCREEN_ARGS_ACTION:
      {
        return state.deleteIn([action.screenKey, 'args'].concat(action.path));
      }
    case _SetScreenDataAction.SET_SCREEN_DATA_ACTION:
      {
        return state.setIn([action.screenKey, 'data'].concat(action.path), (0, _immutable.fromJS)(action.value));
      }
    case _RemoveScreenDataAction.REMOVE_SCREEN_DATA_ACTION:
      {
        return state.deleteIn([action.screenKey, 'data'].concat(action.path));
      }
    case _SetScreenCustomAction.SET_SCREEN_CUSTOM_ACTION:
      {
        return state.setIn([action.screenKey, 'custom'].concat(action.path), (0, _immutable.fromJS)(action.value));
      }
    case _RemoveScreenCustomAction.REMOVE_SCREEN_CUSTOM_ACTION:
      {
        return state.deleteIn([action.screenKey, 'custom'].concat(action.path));
      }
    case _SetScreenInvalidAction.SET_SCREEN_INVALID_ACTION:
      {
        return state.setIn([action.screenKey, 'invalid'].concat(action.path), (0, _immutable.fromJS)(action.value));
      }
    case _RemoveScreenInvalidAction.REMOVE_SCREEN_INVALID_ACTION:
      {
        return state.deleteIn([action.screenKey, 'invalid'].concat(action.path));
      }
    case _SetScreenUpdatedAction.SET_SCREEN_UPDATED_ACTION:
      {
        return state.setIn([action.screenKey, 'updated'].concat(action.path), (0, _immutable.fromJS)(action.value));
      }
    case _RemoveScreenUpdatedAction.REMOVE_SCREEN_UPDATED_ACTION:
      {
        return state.deleteIn([action.screenKey, 'updated'].concat(action.path));
      }
    case _PerformanceStartStoryActionCreator.PERFORMANCE_START_STORY_ACTION:
      {
        var newState = state.setIn([action.screenKey, 'performanceTrack', 'name'], action.name);
        return newState.setIn([action.screenKey, 'performanceTrack', 'id'], action.id);
      }
    case _PerformanceEndStoryAction.PERFORMANCE_END_STORY_ACTION:
      {
        return state.setIn([action.screenKey, 'performanceTrack'], new PerformanceTrack());
      }
    case _ShowDialogAction.SHOW_DIALOG_ACTION:
      {
        var dialogState = new ScreenState().set('id', action.dialogId);
        dialogState = dialogState.set('data', (0, _immutable.fromJS)(action.args));
        return state.setIn([action.dialogId], dialogState);
      }
    case _HideDialogAction.HIDE_DIALOG_ACTION:
      {
        return state.delete(action.dialogId);
      }
    case _NavigationResetAction.NAVIGATION_RESET_ACTION:
      {
        return state.setIn([action.screenKey], new ScreenState());
      }
    case _FieldEditUpdateAction.FIELD_EDIT_UPDATE_ACTION:
      {
        var _newState = state.setIn([action.screenKey, 'updated'].concat(action.path), (0, _immutable.fromJS)(action.value));
        return _newState.setIn([action.screenKey, 'data'].concat(action.path), (0, _immutable.fromJS)(action.value));
      }
    case _AppEntryLoadDataAction.APP_ENTRY_LOAD_DATA_ACTION:
      {
        var _newState2 = state.setIn([action.screenKey, 'id'], action.screenId);
        return _newState2.setIn([action.screenKey, 'args'], (0, _immutable.fromJS)(action.screenArgs));
      }
    default:
      {
        return state;
      }
  }
}

/**
 * returns screen messages
 * @param {Map<string,any>} state 
 * @param {string} [screenKey] 
 */
var getScreenMessages = exports.getScreenMessages = function getScreenMessages(state) {
  var screenKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _ScreenKeyConst.ACTIVE_SCREEN_KEY;

  return state.getIn([screenKey, 'messages']);
};

/**
 * returns screen id
 * @param {Map<string,any>} state 
 * @param {string} [screenKey] 
 */
var getScreenId = exports.getScreenId = function getScreenId(state) {
  var screenKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _ScreenKeyConst.ACTIVE_SCREEN_KEY;

  return state.getIn([screenKey, 'id']);
};

/**
 * returns screen data at the indicated path
 * @param {Map<string,any>} state
 * @param {string[]} [path]
 * @param {string} [screenKey]
 */
var getScreenArgs = exports.getScreenArgs = function getScreenArgs(state) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var screenKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _ScreenKeyConst.ACTIVE_SCREEN_KEY;

  return state.getIn([screenKey, 'args'].concat(path));
};

/**
 * returns screen data at the indicated path
 * @param {Map<string,any>} state
 * @param {string[]} [path]
 * @param {string} [screenKey]
 */
var getScreenData = exports.getScreenData = function getScreenData(state) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var screenKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _ScreenKeyConst.ACTIVE_SCREEN_KEY;

  return state.getIn([screenKey, 'data'].concat(path));
};

/**
 * returns screen custom at the indicated path
 * @param {Map<string,any>} state
 * @param {string[]} [path]
 * @param {string} [screenKey]
 */
var getScreenCustom = exports.getScreenCustom = function getScreenCustom(state) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var screenKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _ScreenKeyConst.ACTIVE_SCREEN_KEY;

  return state.getIn([screenKey, 'custom'].concat(path));
};

/**
 * returns screen custom at the indicated path
 * @param {Map<string,any>} state
 * @param {string[]} [path]
 * @param {string} [screenKey]
 */
var getScreenInvalid = exports.getScreenInvalid = function getScreenInvalid(state) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var screenKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _ScreenKeyConst.ACTIVE_SCREEN_KEY;

  return state.getIn([screenKey, 'invalid'].concat(path));
};

/**
 * returns screen updated at the indicated path
 * @param {Map<string,any>} state
 * @param {string[]} [path]
 * @param {string} [screenKey]
 */
var getScreenUpdated = exports.getScreenUpdated = function getScreenUpdated(state) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var screenKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _ScreenKeyConst.ACTIVE_SCREEN_KEY;

  return state.getIn([screenKey, 'updated'].concat(path));
};

/**
 * returns if screen has outstanding updates pending
 * @param {Map<string,any>} state 
 * @param {string} [screenKey]
 */
var isDirty = exports.isDirty = function isDirty(state) {
  var screenKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _ScreenKeyConst.ACTIVE_SCREEN_KEY;

  var updated = getScreenUpdated(state, [], screenKey);

  if (!updated) {
    return false;
  }

  return updated.size > 0;
};

/**
 * Returns the performance track id information
 * @param {Map<string,any>} state 
 * @param {string} [screenKey] 
 */
var getScreenPerformanceTrack = exports.getScreenPerformanceTrack = function getScreenPerformanceTrack(state) {
  var screenKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _ScreenKeyConst.ACTIVE_SCREEN_KEY;

  return state.getIn([screenKey, 'performanceTrack']);
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/screen/ScreenReducer.js
// module id = 35
// module chunks = 10